export var ToastType;
(function (ToastType) {
    ToastType["success"] = "toast-success";
    ToastType["danger"] = "toast-danger";
    ToastType["warning"] = "toast-warning";
    ToastType["info"] = "toast-info";
})(ToastType || (ToastType = {}));
